// Historial local (localStorage) de movimientos de Iniciar/Reiniciar/Igualar
// sobre los cronómetros de salida — permite consultar la hora de inicio
// aunque la escritura a Firebase todavía no haya confirmado o haya fallado
// por red. Es un log: cada movimiento AGREGA registros, nunca sobrescribe.
// Sigue la misma convención de llave "DASHPORT/{eventoId}/..." que ya usa
// el resto del panel (ver events-actions.js, registros de puntos de control).

const SUFIJO = "/crono_historial";

function storageKey(eventoId) {
  return `DASHPORT/${eventoId}${SUFIJO}`;
}

export function leerHistorial(eventoId) {
  try {
    const raw = localStorage.getItem(storageKey(eventoId));
    return raw ? JSON.parse(raw) : [];
  } catch (e) {
    console.log("Error leyendo historial de cronos", e);
    return [];
  }
}

// registros: arreglo de objetos (un movimiento puede afectar varias series
// a la vez, ej. "Iniciar" sobre 3 seleccionadas -> 3 registros).
export function agregarHistorial(eventoId, registros) {
  try {
    const actuales = leerHistorial(eventoId);
    const nuevos = actuales.concat(registros);
    localStorage.setItem(storageKey(eventoId), JSON.stringify(nuevos));
  } catch (e) {
    console.log("Error guardando historial de cronos", e);
  }
}
